import { useEffect, useMemo, useState } from "react";
import { DescriptionCode } from "@/data/description-codes.data";

const matchDescriptionCode = (descriptionCode: DescriptionCode) => {
  switch (descriptionCode) {
    case "starting":
      // percent: 0
      return "Starting AI song converting...";
    case "starting-stem":
      // percent: 0
      return "Starting AI song splitting...";
    case "waiting-convert":
      // percent: 0
      //      return "Waiting for another song conversion to finish...";
      return "Waiting for another task to finish... It may take 15-60 seconds...";
    // percent: 0.15
    case "loading-models":
      return "Loading voice models...";
    // percent: 0.20
    case "processing-input-file":
      return "Processing input file...";
    case "separating-vocal":
      // percent: 0.2 | 0.3
      return "Preparing vocal in the song...";
    case "preparing-process":
      // percent: 0.4
      return "Preparing the generating processes...";
    case "generating-music":
      // percent: 0.5
      return "Generating music...";
    case "applying-dereverb":
      // percent: 0.3
      return "Applying DeReverb for the song...";
    case "converting-voice":
      // percent: 0.5
      return "Changing voice to AI model...";
    case "splitting-stems":
      // percent: 0.5
      return "Splitting instruments for the song...";
    case "mastering":
      // percent: 0.5
      return "Mastering...";
    case "applying-audio-effects":
      // percent: 0.8
      return "Applying audio effects on changed voice...";
    case "saving-results":
      // percent: 0.8
      return "Saving results for the song...";
    case "saving-speech-results":
      // percent: 0.8
      return "Saving results for the generated speech...";
    case "applying-overall-pitch":
      // percent: 0.85
      return "Applying pitch...";
    case "combining-voc-with-inst":
      // percent: 0.9
      return "Combining the altered vocals with the song's instrumental...";
    case "finishing":
      // percent: 0.95
      return "Finishing AI conversion...";
    case "uploading-mastering-result":
      // percent: 0.95
      return "Uploading mastering results...";
    default:
      // for empty description code
      return "Converting...";
  }
};

const getMaxPercent = (percent: number) => {
  switch (percent) {
    case 0:
      return 0.1;
    case 0.1:
    case 0.2:
      return 0.3;
    case 0.3:
      return 0.5;
    case 0.5:
      return 0.8;
    case 0.8:
      return 0.85;
    case 0.85:
      return 0.9;
    case 0.9:
      return 0.95;
    case 0.95:
      return 1;
    default:
      return -1;
  }
};

const useProgressData = (percent: number, descriptionCode: DescriptionCode) => {
  const [displayPercent, setDisplayPercent] = useState(percent);
  const maxPercent = useMemo(() => getMaxPercent(percent), [percent]);
  const descriptionMessage = useMemo(
    () => matchDescriptionCode(descriptionCode),
    [descriptionCode],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (maxPercent === -1) {
        clearInterval(interval);
        return;
      }

      setDisplayPercent((prevCount) => {
        const newCount = prevCount + (maxPercent - prevCount) * 0.15;
        return newCount >= maxPercent ? maxPercent : newCount;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [percent, maxPercent]);

  return {
    displayPercent: Math.ceil(displayPercent * 100),
    descriptionMessage,
  };
};

export default useProgressData;
